import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircleAlert } from "lucide-react";

const InvalidFeedType = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown === 0) {
      navigate("/feed?type=for_you");
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, navigate]);

  const handleButtonClick = () => {
    navigate("/feed?type=for_you");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
      
      {/* Circle Alert Icon */}
      <div className="w-24 h-24 flex items-center justify-center rounded-full bg-gray-50 mb-6">
        <CircleAlert className="w-12 h-12 text-black" />
      </div>

      {/* Heading */}
      <h2 className="text-xl font-semibold mb-2 text-black">
        Invalid Feed Type
      </h2>

      {/* Subtext */}
      <p className="text-gray-500 mb-2 max-w-sm">
        The feed type you requested is not valid.
      </p>

      {/* Countdown Message */}
      <p className="text-gray-600 text-sm mb-6">
        Redirecting to your feed in <span className="font-semibold text-black">{countdown}s</span>...
      </p>

      {/* Button */}
      <button 
        onClick={handleButtonClick}
        className="px-6 py-2 font-semibold bg-[#b0d284] text-black hover:bg-[#9ec170] transition-all duration-200 active:scale-95 rounded-full"
      >
        Go to Feed Now
      </button>
    </div>
  );
};

export default InvalidFeedType;